import {createRouter, createWebHistory} from 'vue-router';
import {CPRouterPaths, CPTutQuoteRouterPaths} from './paths';

export {CPRouterPaths, CPTutQuoteRouterPaths} from './paths';

function getVueBasePath() {
    const fullPath = window.location.pathname;
    const match = fullPath.match(new RegExp(`(.*${CPRouterPaths.indexPage})(/|$)`));
    return match ? match[1] + '/' : '/';
}

const basePath = getVueBasePath();

const customerPortalRoutes = [
    {
        path: CPRouterPaths.homePage,
        component: () => import('@/apps/website/customer-portal/views/CPHomeView.vue'),
        meta: {breadcrumb: 'Home'},
    },
    {
        path: CPRouterPaths.profilePage,
        component: () => import('@/apps/website/customer-portal/views/CPProfileView.vue'),
        meta: {breadcrumb: 'My Profile'},
    },
    {
        path: CPRouterPaths.editProfilePage,
        component: () => import('@/apps/website/customer-portal/views/CPEditProfileView.vue'),
        meta: {breadcrumb: 'Edit profile', parent: CPRouterPaths.profilePage},
    },
    {
        path: CPRouterPaths.editTutQuoteSettingsPage,
        component: () => import('@/apps/website/customer-portal/views/CPEditTutQuoteSettingsView.vue'),
        meta: {breadcrumb: 'Edit TutQuote settings', parent: CPRouterPaths.profilePage},
    },
    {
        path: CPRouterPaths.changePasswordPage,
        component: () => import('@/apps/website/customer-portal/views/CPChangePasswordView.vue'),
        meta: {breadcrumb: 'Change password', parent: CPRouterPaths.profilePage},
    },
    {
        path: CPRouterPaths.quotesPage,
        component: () => import('@/apps/website/customer-portal/views/CPQuotesView.vue'),
        meta: {breadcrumb: 'HTCH Quotes'},
    },
    {
        path: CPRouterPaths.htchHelpPage,
        component: () => import('@/apps/website/customer-portal/views/CPHTCHHelpView.vue'),
        meta: {breadcrumb: 'HTCH Quotes Help', parent: CPRouterPaths.quotesPage},
    },
    {
        path: CPRouterPaths.singleQuotePage,
        component: () => import('@/apps/website/customer-portal/views/CPSingleQuoteView.vue'),
        meta: {breadcrumb: 'Quote Details', parent: CPRouterPaths.quotesPage},
    },
    {
        path: CPRouterPaths.shareQuotePage,
        component: () => import('@/apps/website/customer-portal/views/CPShareQuoteView.vue'),
        meta: {breadcrumb: 'Quote Details for Sharing', parent: CPRouterPaths.quotesPage},
    },
    {
        path: CPRouterPaths.createHTCHQuotePage,
        component: () => import('@/apps/website/customer-portal/views/CPCreateHTCHQuoteView.vue'),
        meta: {
            breadcrumb: (route: any) => route.query['edit-quote-item-uid'] ? 'Edit HTCH quote item' : route.query['quote-uid'] ? 'Add item to HTCH quote' : 'Create HTCH quote',
            parent: CPRouterPaths.quotesPage,
        },
    },
    {
        path: CPRouterPaths.companyInfoPage,
        component: () => import('@/apps/website/customer-portal/views/CPCompanyInfoView.vue'),
        meta: {breadcrumb: 'My Company Info'},
    },
    {
        path: CPRouterPaths.createAddressPage,
        component: () => import('@/apps/website/customer-portal/views/CPCreateAddressView.vue'),
        meta: {breadcrumb: 'Create address', parent: CPRouterPaths.companyInfoPage},
    },
    {
        path: CPRouterPaths.editAddressPage,
        component: () => import('@/apps/website/customer-portal/views/CPEditAddressView.vue'),
        meta: {breadcrumb: 'Edit address', parent: CPRouterPaths.companyInfoPage},
    },
    {
        path: CPRouterPaths.authPage,
        component: () => import('@/apps/website/customer-portal/views/CPAuthView.vue'),
        meta: {breadcrumb: 'Authentication'},
    },
    {
        path: CPTutQuoteRouterPaths.indexPage,
        component: () => import('@/apps/website/tutquote/TutQuoteVue3App.vue'),
        meta: {breadcrumb: 'TutQuotes'},
        children: [
            {
                path: CPTutQuoteRouterPaths.homePage,
                name: 'home',
                component: () => import('@/apps/website/tutquote/views/TutQuoteHomeView.vue'),
                meta: {breadcrumb: 'Weekly Data', parent: CPTutQuoteRouterPaths.indexPage},
            },
            {
                path: CPTutQuoteRouterPaths.quotesPage,
                name: 'quote-list',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuotesListView.vue'),
                meta: {breadcrumb: 'Quotes', parent: CPTutQuoteRouterPaths.indexPage},
            },
            {
                path: CPTutQuoteRouterPaths.createQuotePage,
                name: 'quote-edit',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuoteEditView.vue'),
                meta: {
                    breadcrumb: 'New Quote',
                    parent: `${CPTutQuoteRouterPaths.indexPage}/${CPTutQuoteRouterPaths.quotesPage}`,
                },
            },
            {
                path: CPTutQuoteRouterPaths.quoteDetailPage,
                name: 'quote-detail',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuoteDetailView.vue'),
                meta: {
                    breadcrumb: 'Quote Details',
                    parent: `${CPTutQuoteRouterPaths.indexPage}/${CPTutQuoteRouterPaths.quotesPage}`,
                },
            },
            {
                path: CPTutQuoteRouterPaths.editQuotePage,
                name: 'quote-edit-existing',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuoteEditView.vue'),
                meta: {
                    breadcrumb: 'Edit Quote',
                    parent: `${CPTutQuoteRouterPaths.indexPage}/${CPTutQuoteRouterPaths.quoteDetailPage}`,
                },
            },
            {
                path: CPTutQuoteRouterPaths.quoteOrderPage,
                name: 'quote-order',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuoteOrderView.vue'),
                meta: {
                    breadcrumb: 'Place Order',
                    parent: `${CPTutQuoteRouterPaths.indexPage}/${CPTutQuoteRouterPaths.quoteDetailPage}`,
                },
            },
            {
                path: CPTutQuoteRouterPaths.createQuoteItemPage,
                name: 'quote-item-create',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuoteItemEditView.vue'),
                meta: {
                    breadcrumb: 'New Item',
                    parent: `${CPTutQuoteRouterPaths.indexPage}/${CPTutQuoteRouterPaths.quoteDetailPage}`,
                },
            },
            {
                path: CPTutQuoteRouterPaths.editQuoteItemPage,
                name: 'quote-item-edit',
                component: () => import('@/apps/website/tutquote/views/TutQuoteQuoteItemEditView.vue'),
                meta: {
                    breadcrumb: 'Edit Item',
                    parent: `${CPTutQuoteRouterPaths.indexPage}/${CPTutQuoteRouterPaths.quoteDetailPage}`,
                },
            },
            {
                path: CPTutQuoteRouterPaths.usersPage,
                name: 'user-list',
                component: () => import('@/apps/website/tutquote/views/TutQuoteUserListView.vue'),
                meta: {breadcrumb: 'Users', parent: CPTutQuoteRouterPaths.indexPage},
            },
            {
                path: CPTutQuoteRouterPaths.poLookupPage,
                name: 'po-lookup',
                component: () => import('@/apps/website/tutquote/views/TutQuotePoLookupView.vue'),
                meta: {breadcrumb: 'PO Lookup', parent: CPTutQuoteRouterPaths.indexPage},
            },
            {
                path: CPTutQuoteRouterPaths.helpPage,
                name: 'help',
                component: () => import('@/apps/website/tutquote/views/TutQuoteHelpView.vue'),
                meta: {breadcrumb: 'Help', parent: CPTutQuoteRouterPaths.indexPage},
            },
        ],
    },
];

const CustomerPortalRouter = createRouter({
    history: createWebHistory(basePath),
    routes: customerPortalRoutes,
    scrollBehavior() {
        return {top: 0, left: 0};
    },
});

export default CustomerPortalRouter;
